module.exports = __webpack_public_path__ + "static/media/SmartShop_7-270w.50d49861.webp";